import _typeof from "babel-runtime/helpers/typeof";
import _toConsumableArray from "babel-runtime/helpers/toConsumableArray";
/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Helper methods
 * -----------------------------------------------------------------------------
 *
 * @namespace helpers
 */

import moment from 'moment';
// In case you want to change moment.js locale, here is an example:
/*
import 'moment/locale/en-gb'
moment.locale('en-gb')
*/

var swatchesColorList = JSON.parse($('[data-swatches-colorlist-json]').html());

var helperMethods = {
  methods: {

    /**
     * Helper method for getting the current template
     */
    _getCurrentTemplate: function _getCurrentTemplate() {
      var template = $('[data-template]').data('template');

      switch (template) {
        case 'collection':
          app.currentTemplate = 'collection';
          break;
        case 'product':
          app.currentTemplate = 'product';
          break;
        case 'cart':
          app.currentTemplate = 'cart';
          break;
        case 'account':
          app.currentTemplate = 'account';
          break;
        case 'index':
          app.currentTemplate = 'index';
          break;
        case 'blog':
          app.currentTemplate = 'blog';
          break;
        case 'article':
          app.currentTemplate = 'article';
          break;
        case 'training':
          app.currentTemplate = 'training';
          break;
      }
    },


    /**
     * Return an object from an array of objects that matches the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    _findInstance: function _findInstance(array, key, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][key] === value) {
          return array[i];
        }
      }
      return null;
    },


    /**
     * Remove an object from an array of objects by matching the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    _removeInstance: function _removeInstance(array, key, value) {
      var i = array.length;
      while (i--) {
        if (array[i][key] === value) {
          array.splice(i, 1);
          break;
        }
      }
      return array;
    },


    /**
     * _.compact from lodash
     * Remove empty/false items from array
     * Source: https://github.com/lodash/lodash/blob/master/compact.js
     *
     * @param {array} array
     */
    _compact: function _compact(array) {
      var index = -1;
      var length = array == null ? 0 : array.length;
      var resIndex = 0;
      var result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },


    /**
     * Remove duplicates from an array of objects
     * @param arr - Array of objects
     * @param prop - Property of each object to compare
     * @returns {Array}
     */
    _removeDuplicates: function _removeDuplicates(arr) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';

      var map = new Map();
      // eslint-disable-next-line array-callback-return
      arr.map(function (el) {
        if (!map.has(el[key])) {
          map.set(el[key], el);
        }
      });
      return [].concat(_toConsumableArray(map.values()));
    },


    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    _defaultTo: function _defaultTo(value, defaultValue) {
      return value == null ? defaultValue : value;
    },


    /**
     * Format date
     * @param  {string}
     * @return {String} value - formatted value
     */
    _formatDate: function _formatDate(value) {
      var date = moment(value).utc().format('MMM D, YYYY');
      return date;
    },


    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @return {String} value - formatted value
     */
    _formatMoney: function _formatMoney(cents) {
      var app = this;
      var moneyFormat = app.moneyFormat;

      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = app._defaultTo(precision, 2);
        thousands = app._defaultTo(thousands, ',');
        decimal = app._defaultTo(decimal, '.');

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, ',', '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return formatString.replace(placeholderRegex, value);
    },


    /**
     * Gets the text of an element and converts to current currency
     *
     * @returns {*} - Returns the new text (currency) of the element
     */
    _checkCurrencyElements: function _checkCurrencyElements() {
      var $currencyEl = $('[data-currency]');
      var amount = $currencyEl.text() * 100;
      var money = app._formatMoney(amount);
      $currencyEl.text(money);
    },


    /**
     * Converts a string to camelcase
     *
     * @param {*} str - String to check
     * @returns {*} - Returns the resolved string
     */
    _toCamelCase: function _toCamelCase(str) {
      return str.toLowerCase().replace(/(?:(^.)|(\s+.))/g, function (match) {
        return " " + match.charAt(match.length - 1).toUpperCase();
      });
    },


    /**
     * Converts a string as handle
     *
     * @param {*} str - String to check
     * @returns {*} - Returns the resolved string
     */
    _handleize: function _handleize(str) {
      str = str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, '-').replace(/^-+|-+$/g, '');
      return str;
    },


    /**
     * Converts a handle to readable friendly format
     *
     * @param {*} str - String to check
     * @returns {*} - Returns the resolved string
     */
    _unhandleize: function _unhandleize(str) {
      str = str.replace(/-/g, ' ');
      str = this._toCamelCase(str);
      return str;
    },


    /**
     * Truncates a given string
     *
     * @param {String} value - Value to check
     * @param {Number} count - Count number of words
     * @returns {*} - Returns the resolved value
     */
    _truncate: function _truncate(value, count) {
      var strippedString = value.trim();
      var array = strippedString.split(' ');
      value = array.splice(0, count).join(' ');
      if (array.length > count) {
        value += '...';
      }
      return value;
    },


    /**
     * Returns a function, that, as long as it continues to be invoked, will not
     * be triggered. The function will be called after it stops being called for
     * N milliseconds. If `immediate` is passed, trigger the function on the
     * leading edge, instead of the trailing.
     */
    _debounce: function _debounce(func, wait, immediate) {
      var timeout = void 0;
      return function () {
        var context = this;
        var args = arguments;

        function later() {
          timeout = null;
          if (!immediate) {
            func.apply(context, args);
          }
        }

        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
          func.apply(context, args);
        }
      };
    },


    /**
     * Pre-loads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */

    _preload: function _preload(images, size) {
      var app = this;

      if (typeof images === 'string') {
        images = [images];
      }

      for (var i = 0; i < images.length; i += 1) {
        var image = images[i];
        app._loadImage(app._getSizedImageUrl(image, size));
      }
    },


    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    _loadImage: function _loadImage(path) {
      new Image().src = path;
    },


    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    _imageSize: function _imageSize(src) {
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

      if (match) {
        return match[1];
      }
      return null;
    },


    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param {string} src
     * @param {string} size
     * @returns {*}
     */
    _getSizedImageUrl: function _getSizedImageUrl(src, size) {
      var app = this;
      var match = void 0;

      if (src === null) {
        return;
      }

      if ((typeof src === "undefined" ? "undefined" : _typeof(src)) === 'object') {
        src = src.src;
      }

      if (size === 'master') {
        src = app._removeProtocol(src);
      }

      if (src) {
        match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
      }

      if (match) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        src = app._removeProtocol(prefix[0] + "_" + size + suffix);
      }
      return src;
    },


    /**
     * Get swatch hex color code or image url
     *
     * @param {string} colorName
     * @returns {string} hex code
     */
    _getSwatchStyle: function _getSwatchStyle(colorName) {
      colorName = colorName.replace(/-|\s/g, '').toLowerCase();
      var swatch = swatchesColorList[colorName];
      var swatchStyle = void 0;

      if (typeof swatch !== 'undefined') {
        if (swatch.match(/\.(jpeg|jpg|png|gif)/g) != null) {
          swatchStyle = "background-image: url(" + swatch + ")";
        } else {
          swatchStyle = "background-color: " + swatch;
        }
        return swatchStyle;
      }

      return false;
    },
    _removeProtocol: function _removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    },


    /**
     * Read a stored cookie by name
     *
     * @param {string} name
     * @return {String} value
     */
    _getCookie: function _getCookie(name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");

      if (parts.length === 2) {
        name = parts.pop().split(';').shift();
      }
      return name;
    },


    /**
     * Cross browser resize event
     */
    _triggerResize: function _triggerResize() {
      if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
        var evt = document.createEvent('UIEvents');
        evt.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(evt);
      } else {
        window.dispatchEvent(new Event('resize'));
      }
    },


    /**
     * Get URL parameter
     */
    _getUrlParameter: function _getUrlParameter(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
  }
};

export default helperMethods;